export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "03f40d95ca68c6f7000a.worker.js");
}
